import { TranslatedItem } from '../../../SimpleCheckList'

export const defaultBenefitBullets: TranslatedItem[] = [
  {
    tKey: 'premium_feature.feature.general.bullet_1',
  },
  {
    tKey: 'premium_feature.feature.general.bullet_2',
  },
  {
    tKey: 'premium_feature.feature.general.bullet_3',
  },
]

export const defaultBillyBenefitBullets: TranslatedItem[] = [
  {
    tKey: 'premium_feature.feature.general.billy.bullet_1',
  },
  {
    tKey: 'premium_feature.feature.general.billy.bullet_2',
  },
  {
    tKey: 'premium_feature.feature.general.billy.bullet_3',
  },
]
